// import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../../utils/axiosInstance";

// export const updatemediatemplateApi = createAsyncThunk("updatemediatemplate", async (formData) => {
//     const response = await axiosInstance.post(`/updatemediatemplate/${formData._id}`, formData, {
//         headers: {
//             "Content-Type": "multipart/form-data",
//         },
//     });
//     return response.data;
// });

// const updateMediaSlice = createSlice({
//     name: "updatemediatemplate",
//     initialState: {
//         updatemediatemplate: [],
//         errors: [],
//         loading: false,
//     },
//     reducers: {},
//     extraReducers: (builder) => {
//         builder
//             .addCase(updatemediatemplateApi.pending, (state) => {
//                 state.loading = true;
//             })
//             .addCase(updatemediatemplateApi.fulfilled, (state, action) => {
//                 state.updatemediatemplate = action.payload;
//                 state.loading = false;
//             })
//             .addCase(updatemediatemplateApi.rejected, (state, action) => {
//                 state.errors = action.payload || action.error.message;
//                 state.loading = false;
//             });
//     },
// });

// export default updateMediaSlice.reducer;

// src/app/slices/collateral/updateMediaSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const updatemediatemplateApi = createAsyncThunk(
  "updatemediatemplate",
  async (formData) => {
    const formDataToSend = new FormData();
    formDataToSend.append("title", formData?.title);
    formDataToSend.append("category_name", formData?.category_name);

    if (formData.mediatemplate_upload) {
      formDataToSend.append(
        "mediatemplate_upload",
        formData?.mediatemplate_upload
      );
    }

    const response = await axiosInstance.post(
      `/updatemediatemplate/${formData._id}`,
      formDataToSend,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log("response+++++++++++++++++++++++++++++++++++++++", response.data)
    return response.data;
  }
);

const updateMediaSlice = createSlice({
  name: "updatemediatemplate",
  initialState: {
    updatemediatemplate: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatemediatemplateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updatemediatemplateApi.fulfilled, (state, action) => {
        state.updatemediatemplate = action.payload;
        state.loading = false;
      })
      .addCase(updatemediatemplateApi.rejected, (state, action) => {
        state.errors = action.payload || action.error.message;
        state.loading = false;
      });
  },
});

export default updateMediaSlice.reducer;
